import React from 'react';
import StatusBarSVG from '../svg/StatusBarSVG';

const Header = ({ text, gravatar, gravatarUrl }) => (
  <div className="auth0-lock-header">
    {gravatar && <img src={gravatarUrl} className="auth0-lock-header-avatar" alt="Avatar" />}
    <div className="auth0-lock-header-bg auth0-lock-blur-support auth0-lock-no-grayscale">
      <div
        className="auth0-lock-header-bg-blur"
        style={{ backgroundImage: `url(${gravatarUrl})` }}
      />
      <div className="auth0-lock-header-bg-solid" style={{ backgroundColor: 'rgb(234, 83, 35)' }} />
    </div>
    <div className="auth0-lock-header-welcome">
      <img
        className={`auth0-lock-header-logo ${gravatar ? 'auth0-header-logo-disabled' : ''}`}
        src="https://cdn.auth0.com/styleguide/components/1.0.8/media/logos/img/badge.png"
      />
      <div className="auth0-lock-name">
        {text}
      </div>
    </div>
  </div>
);

export default Header;



// WEBPACK FOOTER //
// ./src/components/LockDeviceType/components/Header.js